export default "__VITE_ASSET__vbRDQDD4__"